import { Body } from "./body";
import { Muted } from "./muted";
import { SubTitle } from "./sub-title";
import { Title } from "./title";

export const Typo = {
  Title,
  SubTitle,
  Body,
  Muted,
};
